"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PINNBET_DOMAIN = "online.pinnbet.admiral.elbet.com";
var translation = window['langArr'][window['language']];
var VersionSwitcher = (function () {
    function VersionSwitcher() {
        this.htmlRenderElem = document.querySelector('.switcher');
    }
    VersionSwitcher.prototype.specificDomainChanges = function () {
        switch (window.location.hostname) {
            case PINNBET_DOMAIN:
                if (window.V4 == 3) {
                    var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                    gamePlayHolder.classList.remove("game-holder-bar");
                    gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                }
                break;
            case ZB_DOMAIN:
                var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                gamePlayHolder.classList.remove("game-holder-bar");
                gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                break;
            case WELDMAG_DOMAIN:
                if (window.V4 == 3) {
                    var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                    gamePlayHolder.classList.remove("game-holder-bar");
                    gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['weldmag_regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                }
                break;
        }
    };
    VersionSwitcher.prototype.switch = function (v4Game) {
        if ((v4Game === 4 && !/terminal/.test(window.location.href) && !/electron=true/.test(window.location.href))
            || location.hostname == 'online.soccer2.elbet.com' || location.hostname == 'online.stage.soccer.elbet.com') {
            this.attachMessagePost();
            var ticketDomElement = document.getElementById('ticketsScroll');
            if (ticketDomElement) {
                ticketDomElement.classList.add('ticketObject');
            }
            var eleBody = 'element-body-for-object';
            var iOS = /iPhone|iPod/.test(navigator.userAgent);
            if (iOS === true) {
                eleBody = 'element-body-iphone-for-object ';
            }
            this.htmlRenderElem.classList.add('video-object');
            this.htmlRenderElem.innerHTML = '';
            this.htmlRenderElem.innerHTML = "\n        <div class=\"" + eleBody + (" video-for-object\">\n          <div class=\"element-header game-holder-bar main-lb-game-holder-bar\">\n          Lucky Balls <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div><span id=\"jackpotDisplay\"></span>\n          </div>\n          <div class=\"element-body\" style=\"height:100%\">\n            <object width=\"100%\" height=\"100%\" data=\"\" id=\"gamePlay\"></object>\n          </div>\n        </div>");
            if (location.hostname == 'online.soccer2.elbet.com') {
                $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls-tv/index.html?r=v&d=online.soccer2.elbet.com');
            }
            else if (location.hostname == 'online.stage.soccer.elbet.com') {
                $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls-tv/index.html?r=v&d=online.stage.soccer.elbet.com');
            }
            else {
                window.lang ? $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + '&lang=' + window.lang) :
                    $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host);
            }
            var UITabs = document.getElementById('tabs');
            if (UITabs)
                UITabs.style.marginTop = "33px";
        }
    };
    VersionSwitcher.prototype.switchForceV5 = function () {
        this.attachMessagePost();
        var ticketDomElement = document.getElementById('ticketsScroll');
        if (ticketDomElement) {
            ticketDomElement.classList.add('ticketObject');
        }
        var eleBody = 'element-body-for-object';
        var iOS = /iPhone|iPod/.test(navigator.userAgent);
        if (iOS === true) {
            eleBody = 'element-body-iphone-for-object ';
        }
        this.htmlRenderElem.classList.add('video-object');
        this.htmlRenderElem.innerHTML = '';
        this.htmlRenderElem.innerHTML = "\n        <div class=\"" + eleBody + (" video-for-object\">\n          <div class=\"element-header game-holder-bar main-lb-game-holder-bar\">\n          Lucky Balls <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div><span id=\"jackpotDisplay\"></span>\n          </div>\n          <div class=\"element-body\" style=\"height:100%\">\n            <object style=\"position:absolute;top : -2000px;\" width=\"100%\" height=\"100%\" data=\"\" id=\"gamePlay\"></object>\n            <object width=\"100%\" height=\"100%\" data=\"\" id=\"gamePlayV5\"></object>\n          </div>\n        </div>");
        window.lang ? $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + '&lang=' + window.lang) :
            $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host);
        console.log("TEST SWITCH ZB ADMIRAL...");
        $('#gamePlayV5').attr('data', 'https://launcher.elbet.com/virtuals/lucky-balls/v5/index.html?company=admiral');
        var UITabs = document.getElementById('tabs');
        if (UITabs)
            UITabs.style.marginTop = "33px";
    };
    VersionSwitcher.prototype.attachMessagePost = function () {
        var self = this;
        window.addEventListener('message', function (event) {
            if (event.data.type === 'ball_drawn') {
                if (event.data.serialNo >= 1 && event.data.serialNo < 37) {
                    window.drawnBalls = 0;
                    window.drawnNumbers = [];
                    window.drawnOddBalls = 0;
                    window.drawnEvenBalls = 0;
                    window.drawnColors = {
                        red: 0,
                        blue: 0,
                        green: 0,
                        brown: 0,
                        yellow: 0,
                        black: 0,
                        orange: 0,
                        purple: 0
                    };
                    var entity_1 = ['red', 'green', 'blue', 'pink', 'brown', 'yellow', 'orange', 'black'];
                    event.data.drawnBalls.forEach(function (element) {
                        window.drawnNumbers.push(element.number);
                        window.drawnBalls++;
                        window.drawnColors[entity_1[element.color]]++;
                        if (self.isOdd(Number(element.number))) {
                            window.drawnOddBalls++;
                        }
                        else {
                            window.drawnEvenBalls++;
                        }
                    });
                    var ticketsEvent = new CustomEvent('update_tickets');
                    window.dispatchEvent(ticketsEvent);
                }
                else if (event.data.serialNo === 20) { }
                else {
                    console.error('Invalid ball number provided');
                }
            }
            if (typeof event.data.type !== 'undefined' && event.data.type === 'get_tickets') {
                var getTicketEvent = new CustomEvent('get_tickets');
                this.window.dispatchEvent(getTicketEvent);
                window.updateResultsV4();
            }
            if (typeof event.data.type !== 'undefined' && event.data.type === 'response_gameplay') {
                this.window['gameDisplayV4'](event.data.response);
                var localHelper = event.data.drawnBalls;
                var localListener = function () {
                    window.drawnBalls = 0;
                    window.drawnNumbers = [];
                    window.drawnOddBalls = 0;
                    window.drawnEvenBalls = 0;
                    window.drawnColors = {
                        red: 0,
                        blue: 0,
                        green: 0,
                        brown: 0,
                        yellow: 0,
                        black: 0,
                        orange: 0,
                        purple: 0
                    };
                    var entity = ['red', 'green', 'blue', 'pink', 'brown', 'yellow', 'orange', 'black'];
                    localHelper.forEach(function (element) {
                        window.drawnNumbers.push(element.number);
                        window.drawnBalls++;
                        window.drawnColors[entity[element.color]]++;
                        if (self.isOdd(Number(element.number))) {
                            window.drawnOddBalls++;
                        }
                        else {
                            window.drawnEvenBalls++;
                        }
                    });
                    var getTicketEvent = new CustomEvent('update_tickets');
                    this.window.dispatchEvent(getTicketEvent);
                    window.removeEventListener('tickets-present', localListener);
                };
                window.addEventListener('tickets-present', localListener, false);
            }
        }, false);
    };
    VersionSwitcher.prototype.isInteger = function (n) {
        return n === parseInt(n);
    };
    VersionSwitcher.prototype.isOdd = function (n) {
        return this.isInteger(n) && (n % 2 !== 0);
    };
    return VersionSwitcher;
}());
exports.default = VersionSwitcher;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/version-switcher/version-switcher.ts
// module id = 1178
// module chunks = 2